import React, { useMemo } from 'react';

import _ from 'lodash';
import { AsyncCreatable } from 'react-select';

const getOptionDefaut = (optionProps) => {
  let { innerProps, isSelected, isFocused } = optionProps;
  let { innerRef, ...filteredProps } = innerProps;
  return <div {...filteredProps} className={'p-1 ' + ((isSelected || isFocused) ? 'bg-light-primary' : '')}>
    {optionProps.label}
  </div>;
};

const MultiValueSelector = ({ onChange, value, options, placeholder, getOptionValue, getOption, getValue, filterOption, ...otherProps }) => {
  const handleSelectChange = (values, actionMeta) => {
    onChange(_.map(values, getOptionValue ? o => getOptionValue(o) : 'value'));
  };

  const getMultiValueLabel = (labelProps) => {    
    let exists = _.includes(value, labelProps.data.value);
    if(getOptionValue) {      
      let values = options.map(o => getOptionValue(o));
      exists = _.includes(values, getOptionValue(labelProps.data));
    }    
    let level = exists ? 'primary' : 'danger';
    return <span className={`badge badge-${level}`}>{labelProps.children}</span>;
  };

  const optionsObjects = useMemo(() => _.map(options, (op) => {        
    if (op.value && op.label) {
      return op;
    } else {      
      return { label: op.toString(), value: op };
    }
  }), [options]);

  let valueOptions = useMemo(() => _.map(value, v => {
    if(getOptionValue) {            
      return _.find(optionsObjects, o => getOptionValue(o) === v) || { label: v.toString(), value: v };
    } else {
      return _.find(optionsObjects, { value: v }) || { label: v.toString(), value: v };
    }
  }), [optionsObjects, value]);


  const loadOptions = async (input) => {    
    let regex = new RegExp(input, 'i');
    let regexStartsWith = new RegExp('^' + input, 'i');
    let matching = optionsObjects.filter(o => o.label.match(regex) || o.value.match(regex));

    // Sort by matching in the value, then by matching in the label from the start
    return _.sortBy(matching, o => o.value.match(regex) ? 0 : 1, o => o.label.match(regexStartsWith) ? 0 : 1);
  };
  
  return (
    <AsyncCreatable
      closeOnSelect={true}
      allowCreateWhileLoading={true}
      isMulti
      components={{
        Option: getOption || getOptionDefaut,
        MultiValueLabel: getValue || getMultiValueLabel
      }}
      onChange={handleSelectChange}
      loadOptions={loadOptions}
      menuShouldScrollIntoView={false}
      placeholder={placeholder || ""}
      value={valueOptions}
      filterOption={filterOption}
      {...otherProps}
    />
  );
};

export default MultiValueSelector;
